import { throwError } from 'rxjs';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpParams } from "@angular/common/http";
import { catchError, map } from "rxjs/operators";
import { ApiService } from '../../core/services/index';

@Injectable({ providedIn: 'root' })
export class identificationService {

    constructor(private _api: ApiService) { }

    save(data) {
        return this._api.post(`${"identification/save"}`, data)
            .pipe(
                map((res: any) => res),
                catchError((error: any) => throwError(() => error))
            );
    }

    getUserCoinIdentification(data) {
        const { user_id, coin_id } = data;
        let httpParams = new HttpParams();
        httpParams = httpParams.append('user_id', user_id);
        httpParams = httpParams.append('coin_id', coin_id);
        return this._api.get(`${"identification/coin/byuser?" + httpParams}`,)
            .pipe(
                map((res: any) => res),
                catchError((error: any) => throwError(() => error))
            );
    }


    getAllCoinIdentifications(coinId) {
        return this._api.get(`${"identification/coin/all/" + coinId}`,)
            .pipe(
                map((res: any) => res),
                catchError((error: any) => throwError(() => error))
            );
    }
        
}

